import React from 'react';
import {Route, Routes, Navigate} from 'react-router-dom';
import {ROUTES} from '@/config/routesConstants';
import Preference from '@/views/preferences';
import Account from '@/views/preferences/account';
import Notifications from '@/views/preferences/notifications';
import TermsOfService from '@/views/preferences/terms-of-service';
import useDashboardUserQuery from '@/hooks/queries/use-dashboard-user-query';
import useToken from '@/hooks/use-token';

export const PREFERENCE_ROUTES = {
  MAIN: '',
  ACCOUNT: 'account',
  NOTIFICATIONS: 'notifications',
  TERMS_OF_SERVICE: 'terms-of-service',
};

function PreferenceRoutes({
  basePath = ROUTES.PREFERENCES,
}: {
  basePath?: string;
}) {
  const {isAuthenticated} = useToken(true);
  const {dashboardUser} = useDashboardUserQuery({
    enabled: isAuthenticated,
  });

  return (
    <Routes>
      <Route path="/" element={<Preference basePath={basePath} />}>
        <Route index element={<Account />} />
        <Route path={PREFERENCE_ROUTES.ACCOUNT} element={<Account />} />
        <Route
          path={PREFERENCE_ROUTES.NOTIFICATIONS}
          element={
            dashboardUser && !dashboardUser.isAdmin ? (
              <Notifications />
            ) : (
              <Navigate to="/preferences/account" replace />
            )
          }
        />
        <Route
          path={PREFERENCE_ROUTES.TERMS_OF_SERVICE}
          element={<TermsOfService />}
        />
      </Route>
    </Routes>
  );
}

export default PreferenceRoutes;
